import { QueryClient } from "react-query";
import { LoaderFunction } from "react-router";
import {
  CurrentUserQuery,
  currentUserQuery,
} from "@/services/auth/useAuthUser";
import {
  CurrentUserDataOrFalseQuery,
  currentUserDataOrFalseQuery,
} from "@/services/reports/useUserData";
import { LOGIN_PATH } from "../login/const";
import isUserDataComplete from "../isUserDataComplete";
import { jumpBack, redirectAndKeepQueryParams } from "../auth-flow";
import { HasSessionQuery, hasSessionQuery } from "@/services/auth/useSession";

export type CreateLoaderConfig = {
  queryClient: QueryClient;
  currentUserQuery: CurrentUserQuery;
  currentUserDataOrFalseQuery: CurrentUserDataOrFalseQuery;
  hasSessionQuery: HasSessionQuery;
};
export const LOADER_CONFIG_DEFAULTS = {
  currentUserQuery,
  currentUserDataOrFalseQuery,
  hasSessionQuery,
};
export default (config: CreateLoaderConfig): LoaderFunction =>
  async ({ request }): Promise<Response | null> => {
    const {
      queryClient,
      currentUserQuery,
      currentUserDataOrFalseQuery,
      hasSessionQuery,
    } = config;

    const hasSession = await queryClient
      .fetchQuery(hasSessionQuery)
      .catch(() => false); // ignore errors
    const user = await queryClient.fetchQuery(currentUserQuery);
    if (!user && !hasSession)
      return redirectAndKeepQueryParams(request.url, `/${LOGIN_PATH}`);

    try {
      // catch user data fetch errors, they are not critical
      const userData = await queryClient.fetchQuery(
        currentUserDataOrFalseQuery,
      );
      if (userData && isUserDataComplete(userData))
        return jumpBack(request.url);
    } catch (e) {
      console.warn("Couldn't fetch user data", e);
    }

    return null;
  };
